import { I18n } from '@calendly/i18n'
import moment from 'moment-timezone'

import { DISPLAY_STATUS, DisplayStatus, getDisplayLabelKey, getStartingSoonRelativeText } from './meeting-helpers'

/**
 * Computes display text for meeting status in the component layer.
 * STARTING_SOON uses Intl (getStartingSoonRelativeText); other statuses use I18n.t(getDisplayLabelKey).
 * Keeps Intl.RelativeTimeFormat separate from meeting-helpers (no I18n there).
 *
 * @param status - Display status from getMeetingStatus
 * @param startTime - Meeting start time (ISO string); required for STARTING_SOON
 * @param currentTime - Current time (moment object)
 * @param locale - Optional locale for relative time; defaults to I18n.locale
 */
export function computeStatusDisplayText(
  status: DisplayStatus,
  startTime: string | undefined,
  currentTime: moment.Moment,
  locale?: string
): string {
  if (status === DISPLAY_STATUS.STARTING_SOON && startTime) {
    const relativeText = getStartingSoonRelativeText(startTime, currentTime, locale ?? I18n.locale)
    if (relativeText) return relativeText
    return I18n.t('publisher.meetings.header_badge.starting_soon')
  }
  const key = getDisplayLabelKey(status)
  return key ? I18n.t(`publisher.meetings.header_badge.${key}`) : ''
}
